var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceDashBoard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1753_3895",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1753_3895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00033 14.5C3.63366 14.5 3.31977 14.3694 3.05866 14.1083C2.79755 13.8472 2.66699 13.5333 2.66699 13.1667V3.83333C2.66699 3.46667 2.79755 3.15278 3.05866 2.89167C3.31977 2.63056 3.63366 2.5 4.00033 2.5H13.3337C13.7003 2.5 14.0142 2.63056 14.2753 2.89167C14.5364 3.15278 14.667 3.46667 14.667 3.83333V13.1667C14.667 13.5333 14.5364 13.8472 14.2753 14.1083C14.0142 14.3694 13.7003 14.5 13.3337 14.5H4.00033ZM4.00033 13.1667H8.00033V3.83333H4.00033V13.1667ZM9.33366 13.1667H13.3337V8.5H9.33366V13.1667ZM9.33366 7.16667H13.3337V3.83333H9.33366V7.16667Z",
    fill: "black",
    fillOpacity: 0.38
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceDashBoard);
export default __webpack_public_path__ + "static/media/SpaceDashBoard.c2fca884.svg";
export { ForwardRef as ReactComponent };